import { InfiniteData } from '@tanstack/query-core';

import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchCollection } from './fetchCollection';

export function isCollectionEmpty({ referenceId, pageSize }: { referenceId: string; pageSize: number }) {
  const data = queryClient.getQueryData<InfiniteData<Awaited<ReturnType<typeof fetchCollection>>>>(
    queryKeys.collection(referenceId, pageSize),
  );

  if (!data) {
    return true;
  }

  const [firstPage] = data.pages;

  return !firstPage.totalCount;
}
